<template>
  <section class="document-contents">
    <h2 class="document-contents__title">
      <span v-html="getTitleBlock(page, 'contents', 'title')"></span>
      <span class="document-contents__accent" v-html="getTitleBlock(page, 'contents', 'description')"></span>
    </h2>
    <ol class="document-contents__list">
      <li v-for="(item, index) in getListBlock(page, 'contents-list')" :key="index" class="document-contents__item">
        <span class="document-contents__number">{{ String(index + 1).padStart(2, '0') }}</span>
        <span v-html="item"></span>
      </li>
    </ol>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  mixins: [ textBlock ],
};
</script>

<style lang="scss" scoped>
.document-contents {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px;
  border-radius: 28px;
  background: #EBF2FF;

  @media (max-width: 800px) {
    padding: 24px 16px;
  }

  &__title {
    margin: 0 0 32px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(30px, 3.4vw, 44px);
    line-height: 1.15;
  }

  &__accent {
    margin-left: 8px;
    background: linear-gradient(90deg, #4555CC, #CC5697 55%, #E67B53);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 12px;
  }

  &__item {
    display: flex;
    gap: 16px;
    align-items: center;
    padding: 18px 22px;
    border-radius: 20px;
    background: #FFFFFF;
    box-shadow: 0 16px 48px rgba(55, 58, 61, 0.10);
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: 17px;
    line-height: 23px;
  }

  &__number {
    flex: none;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: #EBF2FF;
    color: #4555CC;
    font-weight: 600;
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
